import request from '@/utils/request'

export function getJobLevelList (data) { // 取得職級列表
  return request({
    url: '/staff.php',
    method: 'post',
    header: {
      'Content-Type': 'application/json',
      'app': 'admin'
    },
    data: {
      action: 'getJobLevel'
    }
  })
}

export function editStaff (data) { // 填寫表單
  return request({
    url: '/staff.php',
    method: 'post',
    header: {
      'Content-Type': 'multipart/form-data',
      'app': 'admin'
    },
    data
  })
}

export function checkHashStaff (hash) { // 填寫表單
  return request({
    url: '/staff.php',
    method: 'post',
    header: {
      'Content-Type': 'multipart/form-data',
      'app': 'admin'
    },
    data: {
      action: 'checkHash',
      hash: hash
    }
  })
}
